var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "item-card",
      staticStyle: {
        "border-radius": "4px !important",
        border: "1px solid #dee5ec",
      },
      attrs: { shadow: "never", "body-style": "margin: 0px;" },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-row",
          staticStyle: { margin: "8px 24px 8px 8px" },
        },
        [
          _c("div", { staticClass: "flex-1", staticStyle: { margin: "8px" } }, [
            _c(
              "div",
              {
                staticClass: "flex flex-row",
                staticStyle: { margin: "0px 0px 8px 0px" },
              },
              [
                _c("div", { staticClass: "flex-1" }, [
                  _c("strong", [_vm._v("Delivery Address")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Name\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_name) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Phone number\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_phone) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass: "flex-1",
                  staticStyle: { margin: "0px 0px 24px 0px" },
                },
                [_vm._v("\n          Email\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_email) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Street\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.billingAddress.address_1) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          City\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.billingAddress.city) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          State/province/area\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.billingAddress.state) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Zip code\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.billingAddress.zip) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Country\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.billingAddress.country) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { margin: "0px 0px 24px 0px" } }),
            _vm._v(" "),
            _c("div", { staticStyle: { border: "1px solid #DEE5EC" } }),
            _vm._v(" "),
            _c("div", { staticStyle: { margin: "24px 0px 0px 0px" } }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex flex-row",
                staticStyle: { margin: "0px 0px 16px 0px" },
              },
              [
                _c("div", { staticClass: "flex-1" }, [
                  _c("strong", [_vm._v("Billing Address")]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Name\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_name) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Phone number\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_phone) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass: "flex-1",
                  staticStyle: { margin: "0px 0px 24px 0px" },
                },
                [_vm._v("\n          Email\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.customerData.customer_email) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.billingAddress != _vm.shippingAddress
              ? _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n          Street\n        "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-price" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.shippingAddress.address_1) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          City\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.shippingAddress.city) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          State/province/area\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.shippingAddress.state) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Zip code\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.shippingAddress.zip) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("div", { staticClass: "flex-1" }, [
                _vm._v("\n          Country\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-price" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.shippingAddress.country) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.billingAddress === _vm.shippingAddress
              ? _c("div", { staticClass: "flex flex-row" }, [
                  _c("div", { staticClass: "flex-1" }, [
                    _vm._v("\n          Same as Delivery Address\n        "),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }